import { useCallback } from 'react';
import { Button, Form, Input, Spin } from 'antd';

const LinkedAccountForm = ({ onFinish, form, isLoading }: any) => {

    const onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
    };

    type FieldType = {
        email?: string;
    };

    const emailInput = useCallback((inputElement: any) => {
        if (inputElement) {
            inputElement.focus();
        }
    }, []);

    return (
        <Form
            form={form}
            name="basic"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            layout='vertical'
        >
            <Form.Item<FieldType>
                label="Email"
                name="email"
                rules={[{ required: true, message: 'Please enter valid email address', type: "email" }]}
            >
                <Input placeholder='Enter you email' autoFocus ref={emailInput} />
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Button type="primary" htmlType="submit" className='linked__account__submit__btn' disabled={isLoading}>
                    {
                        isLoading ? <>Submit <Spin /> </> : "Submit"
                    }
                </Button>
            </Form.Item>
        </Form>
    )
}

export default LinkedAccountForm